/**
 * Fade-Top / Red-Orange-Green.
 */ var RedOrangeGreen = [
    /**
     * Red Props.
     */ {
        variant: 'red',
        size: '967',
        rotate: 30,
        blur: 21.3,
        x: '-615',
        y: '620'
    },
    /**
     * Orange Props.
     */ {
        variant: 'orange',
        size: '1045',
        rotate: -30,
        blur: 19.3,
        x: '198',
        y: '746'
    },
    /**
     * Green Props.
     */ {
        variant: 'green',
        size: '893',
        rotate: 160,
        blur: 21.3,
        x: '796',
        y: '822'
    }
];

export { RedOrangeGreen as default };
//# sourceMappingURL=red-orange-green.es.js.map
